/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsMultisiteCategoriesCtrl
 * @description A report of sales for all companies grouped by Item Category
 */
angular.module('mercury.modules.reports.multisite')
.controller('ReportsMultisiteCategoriesCtrl', ["comparetime", "$filter", "multisite", "ReportItemCategories", "$q", "reporttime", "$scope", "title", "userinfo", function(comparetime, $filter, multisite, ReportItemCategories, $q, reporttime, $scope, title, userinfo) {
  title.set('Food Vs Beverage');
  multisite.setMultisite(true);

  $scope.compare = comparetime.time() !== null;
  var salesResults = {};
  var compareResults = {};
  $scope.results = [];

  var createResultLine = function(company) {
    // we don't want to add companies to the resultset multiple times, so check the restuls array and only add if it's a new companyId
    var newCompany = true;
    angular.forEach($scope.results, function(result) {
      if (result.companyId == company.id) {
        newCompany = false;
        result.show = '1';
      }
    });

    if (newCompany) {
      $scope.results.push({
        companyId: company.id,
        name: company.name,
        show: '1',
        foodSales: null,
        foodSalesCompare: null,
        foodDiscounts: null,
        foodDiscountsCompare: null,
        beverageSales: null,
        beverageSalesCompare: null,
        beverageDiscounts: null,
        beverageDiscountsCompare: null
      });
    }
  };

  var buildReport = function() {
    $scope.graphColumns = [
      {label: 'Group', type: 'string', key: 'group'},
      {label: 'Sales', type: 'number', key: 'sales', filter: 'currency'}
    ];

    angular.forEach(userinfo.companies(), function(company) {
      // skip any sites that have been deselected
      if (multisite.isCompanyDisabled(company.id)) {
        angular.forEach($scope.results, function(result) {
          if (result.companyId == company.id) {
            result.show = '0';
          }
        });
        $scope.$emit('dataTableUpdate');
        return;
      }

      // fetch any missing result lines
      if (!salesResults[company.id]) {
        salesResults[company.id] = ReportItemCategories.getSales(reporttime.start(), reporttime.end(), company.id);
      }
      if ($scope.compare && !compareResults[company.id]) {
        compareResults[company.id] = ReportItemCategories.getSales(comparetime.start(), comparetime.end(), company.id);
      }

      salesResults[company.id].then(function(salesRequestResult) {
        var foodTotal = $filter('filter')(salesRequestResult, function(category) {
          return category.label.toLowerCase() == 'food';
        });

        var beverageTotal = $filter('filter')(salesRequestResult, function(category) {
          return category.label.toLowerCase() == 'beverage';
        });

        angular.forEach($scope.results, function(resultLine, resultIndex) {
          if (resultLine.companyId == company.id) {
            $scope.results[resultIndex].foodSales = $filter('sumof')(foodTotal, 'invoices');
            $scope.results[resultIndex].foodDiscounts = $filter('sumof')(foodTotal, 'discounts');
            $scope.results[resultIndex].beverageSales = $filter('sumof')(beverageTotal, 'invoices');
            $scope.results[resultIndex].beverageDiscounts = $filter('sumof')(beverageTotal, 'discounts');
          }
        });

        $scope.graphRows = [
          {group: 'Food', sales: $filter('sumof')($filter('filter')($scope.results, {'show': '1'}), 'foodSales')},
          {group: 'Beverage', sales: $filter('sumof')($filter('filter')($scope.results, {'show': '1'}), 'beverageSales')}
        ];

        $scope.$emit('redraw.googleChart');
      });

      if (compareResults[company.id]) {
        compareResults[company.id].then(function(compareRequestResult) {

          var compareFoodTotal = $filter('filter')(compareRequestResult, function(category) {
            return category.label.toLowerCase() == 'food';
          });

          var compareBeverageTotal = $filter('filter')(compareRequestResult, function(category) {
            return category.label.toLowerCase() == 'beverage';
          });

          angular.forEach($scope.results, function(resultLine, resultIndex) {
            if (resultLine.companyId == company.id) {
              $scope.results[resultIndex].foodSalesCompare = $filter('sumof')(compareFoodTotal, 'invoices');
              $scope.results[resultIndex].foodDiscountsCompare = $filter('sumof')(compareFoodTotal, 'discounts');
              $scope.results[resultIndex].beverageSalesCompare = $filter('sumof')(compareBeverageTotal, 'invoices');
              $scope.results[resultIndex].beverageDiscountsCompare = $filter('sumof')(compareBeverageTotal, 'discounts');
            }
          });

          $scope.graphRows = [
            {group: 'Food', sales: $filter('sumof')($scope.results, 'foodSales')},
            {group: 'Beverage', sales: $filter('sumof')($scope.results, 'beverageSales')}
          ];

          $scope.$emit('redraw.googleChart');
        });
      }

      createResultLine(company);
    });
    $scope.$emit('dataTableUpdate');
  };

  // Start fetching the results
  angular.forEach(userinfo.companies(), function(company) {
    // skip any sites that have been deselected
    if (multisite.isCompanyDisabled(company.id)) {
      angular.forEach($scope.results, function(result) {
        if (result.companyId == company.id) {
          result.show = '0';
        }
      });
      $scope.$emit('dataTableUpdate');
      return;
    }

    createResultLine(company);

    salesResults[company.id] = ReportItemCategories.getSales(reporttime.start(), reporttime.end(), company.id);
    if ($scope.compare) {
      compareResults[company.id] = ReportItemCategories.getSales(comparetime.start(), comparetime.end(), company.id);
    }
  });

  $scope.loading = $q.race(salesResults);
  $scope.loading.then(buildReport);
  $scope.$on('userInfoUpdated', buildReport);
}]);
